<template>
  <div>
    <van-popup v-model="show" position="right" style="width:100%;height:100%;">
      <div class="bg-white popup-box">
        <section class="container-footer">
          <div class="popup-del flex all-c">
            <span class="icon icon-chacha f18" @click="show=false"></span><span
              class="flex-1 txt-c f20 pr16">佣金</span>
          </div>
          <div class="home-per">
            <div class="ds-partime-list flex space-b">
              <p class="van-bor1 flex-1 van-hairline--surround"
                 :class="{'selected':commissionType === 0}" @click="commissionType = 0">
                <span class="block txt-elips">全部</span>
              </p>
              <p class="van-bor1 flex-1 van-hairline--surround"
                 :class="{'selected':commissionType === 1}" @click="commissionType = 1">
                <span class="block txt-elips">有佣金</span>
              </p>
              <p class="van-bor1 flex-1 van-hairline--surround"
                 :class="{'selected':commissionType === 2}" @click="commissionType = 2">
                <span class="block txt-elips">无佣金</span>
              </p>
            </div>
          </div>
        </section>
        <footer class="footer-fixed flex all-c">
          <van-button block type="default" class="flex-1 radius-0" @click="clear">
            <span class="f16 c-orange">重置</span>
          </van-button>
          <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="search">
            <span class="f16">确定</span>
          </van-button>
        </footer>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: false,
        // 0:全部 1:有佣金 2:无佣金
        commissionType: 0
      };
    },
    methods: {
      clear() {
        this.commissionType = 0;
      },
      search() {
        let hasCommission = null;
        if (this.commissionType === 1) {
          hasCommission = true;
        } else if (this.commissionType === 2) {
          hasCommission = false;
        }
        this.$emit('search', { hasCommission: hasCommission });
        this.show = false;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/css/theme.less';
  .popup-del{ padding: 10px 0 5px 15px;}
  .drawline {
    height: 1px;
    width: 100%;
  }

  .ds-partime-list {
    margin: 30px 20px;
  }
  .ds-partime-list p{
    margin:0;
    height: 35px;
    line-height: 36px;
    font-size: 14px;
  }
  .ds-partime-list p:not(:last-child){
    margin-right: 20px;
  }

  .fringe .van-cell__value--alone {
    color: #666;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }
</style>
